export enum CampaignStatuses {
  DRAFT = 'draft',
  LIVE = 'live',
  PAUSED = 'paused',
  EXPIRED = 'expired'
}
